export default __webpack_public_path__ + "static/media/BTP Landing Page 3.a13d0c8f.png";